import './bootstrap';

import router from './routes';

import App from './components/App.vue';

import Calendar from './components/Calendar.vue';

Vue.config.productionTip = false

const auth = Laravel.auth;
auth.install = function(){
    Object.defineProperty(Vue.prototype, '$auth', {
        get () { return auth }
    })
}
Vue.use(auth);

const config = Laravel.config;
config.key_masters = window.key_masters;
config.members = window.members;
config.plugin = Laravel.plugin;
config.install = function(){
    Object.defineProperty(Vue.prototype, '$config', {
        get () { return config }
    })
}
Vue.use(config);

// set up translation strings
const lang = window.i18n;
lang.install = function(Vue, options){
    Vue.prototype.lang = (string, args) => {
        let value = _.get(window.i18n, string, string);

        _.eachRight(args, (paramVal, paramKey) => {
            value = _.replace(value, `:${paramKey}`, paramVal);
        });
        return value;
    };
};
Vue.use(lang);

new Vue({
    el: '#app',
	router,
	components: {
        App,
        Calendar
    }
});
